import { Container } from "./styles";

const DataHeaderDetail = ({
    text,
    icon,
    width
}) => {
    return (
        <Container width={width}>
            {icon}
            <span>{text}</span>
        </Container>
    );
}
export default DataHeaderDetail;